import React from "react";

import routes from "./routes";

import { Layout } from "antd";
import { Switch, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import PrivateRoute from "../../components/PrivateRoute";
import NoPageFound from "../../components/NoPageFound";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getSubscribedPlan } from "../../redux/actions/Membership/membership.actions";
import { DEVELOPER, SUPER_ADMIN, SUPER_ADMIN_EDITOR } from "../../config/roles";
const Main = () => {
  const dispatch = useDispatch();
  const { Content } = Layout;
  const {
    user: { role },
  } = useSelector((state) => state?.auth);
  useEffect(() => {
    if (
      !role ||
      role === SUPER_ADMIN ||
      role === SUPER_ADMIN_EDITOR ||
      role === DEVELOPER
    ) {
      return;
    }
    dispatch(getSubscribedPlan());
  }, [dispatch, role]);
  return (
    <div>
      <Content>
        <Switch>
          {routes.map(
            (r, i) => r.role.includes(role) && <Route key={i} {...r} />
          )}
          <PrivateRoute path="*" component={NoPageFound} />
        </Switch>
      </Content>
    </div>
  );
};

export default Main;
